import {
  Box,
  BoxProps,
  Container,
  Flex,
  Skeleton,
  SkeletonCircle,
  Stack,
  useBreakpointValue,
} from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

export interface ContentLoaderProps extends BoxProps {
  header?: boolean;
  avatar?: boolean;
  lines?: number;
  children?: ReactNode;
}

const widths = ['65%', '45%', '80%', '100%', '50%'];
const wLen = widths.length;

const ContentLoader = ({
  header = true,
  avatar = true,
  lines = 3,
  children,
  ...rest
}: ContentLoaderProps): ReactElement | null => {
  const sm = useBreakpointValue({ base: true, md: false });
  const w = sm ? '64' : '48';
  const titleH = sm ? '64px' : '50px';
  const lineH = sm ? '28px' : '20px';
  return (
    <Box w="100%" {...rest}>
      <Flex direction={{ base: 'column', sm: 'row' }}>
        {avatar ? (
          <Flex w={w} mr={10} my={6}>
            <SkeletonCircle size={w} className="avatar" />
          </Flex>
        ) : null}
        <Box w="100%">
          <Stack>
            {header ? <Skeleton h={titleH} mb={6} /> : null}
            <Skeleton w={widths[0]} h={lineH} />
            <Skeleton w={widths[1]} h={lineH} />
            <Skeleton w={widths[2]} h={lineH} />
          </Stack>
        </Box>
      </Flex>
      {lines > 0 && (
        <Stack w={'full'} mt={12}>
          {Array(lines)
            .fill(0)
            .map((_, i) => (
              <Skeleton key={i} w={widths[i % wLen]} h={lineH} />
            ))}
        </Stack>
      )}
      {children}
    </Box>
  );
};

export const pageContentLoader = (
  <Container
    display="flex"
    flexDirection={{ base: 'column', lg: 'row' }}
    gap={[8, 10, 12, 16]}
    maxW="container.xl"
    py={[12, 16, 20, 28]}
  >
    <ContentLoader avatar={false} />
    <Skeleton minW="50%" minH={350} />
  </Container>
);

export default ContentLoader;
